module.exports = __webpack_public_path__ + "img/18-tju-tuda-logo.44096cce.png";